// Validates phone numbers (default format: xxx-xxx-xxxx, but can be passed other RegEx)
import { ValidatorFn, AbstractControl } from '@angular/forms';

export function vehicleYearValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const latestYear = new Date().getFullYear() + 1;
    return control.value <= latestYear ? null : {maxVehicleYear: {value: control.value}};
  };
}
